import { render, staticRenderFns } from "./Improve.vue?vue&type=template&id=541e7cf8&scoped=true&"
import script from "./Improve.vue?vue&type=script&lang=js&"
export * from "./Improve.vue?vue&type=script&lang=js&"
import style0 from "./Improve.vue?vue&type=style&index=0&id=541e7cf8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "541e7cf8",
  null
  
)

export default component.exports